export default __webpack_public_path__ + "static/media/Installment_purchase.c9ef77bc.png";